
































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

import addSubjectVue from "../components/Voucher/addSubject.vue";
import voucherTitleVue from "../components/Voucher/voucherTitle.vue";
import voucherInfoVue from "../components/Voucher/voucherInfo.vue";
import voucherHeadVue from "../components/Voucher/voucherHead.vue";
import voucherRecordVue from "../components/Voucher/voucherRecord.vue";
import voucherTotalVue from "../components/Voucher/voucherTotal.vue";
import saveTemplateVue from "../components/Voucher/saveTemplate.vue";
import useTemplateVue from "../components/Voucher/useTemplate.vue";
import addAssistVue from "../components/Voucher/addAssist.vue";
import defaultRecords from "../components/Voucher/defaultRecords";
import VoucherCopyVue from "../components/VoucherList/VoucherCopy.vue";
import { mapGetters } from "vuex";

@Component({
	...mapGetters(["account", "accountBook"]),
	components: {
		addSub: addSubjectVue,
		voucherTitle: voucherTitleVue,
		voucherInfo: voucherInfoVue,
		voucherHead: voucherHeadVue,
		voucherRecord: voucherRecordVue,
		voucherTotal: voucherTotalVue,
		saveTemplate: saveTemplateVue,
		useTemplate: useTemplateVue,
		addAssist: addAssistVue,
        "voucher-copy": VoucherCopyVue,
	},
})
export default class Voucher extends Vue {
	@Prop({ type: Boolean, default: false })
	isCate: any;
	@Prop({ type: Number, default: -1 })
	cate: any;

	// 判读是否为模态框出现
	isDialog: boolean = false;
	//id
	id: any = null;
	// 新增科目模态框
	addDialog: boolean = false;
	// 可查找下一张,上一张
	canFindPre: boolean = false;
	canFindNext: boolean = false;
	voucherNo: string = "";
	accessoryNo: string = "";
	// 判断是否为插入
	isInsert: number = 0;
	//是否为检查
	isCheck: boolean = false;
	// 绑定的日期
	dateTime: any = {};
	changeStartDate = new Date().getTime();

	get disabledDate() {
		let startPeriod =
			this.$store.state.accountBook.closePeriod == null
				? this.$store.state.accountBook.startPeriod
				: this.$store.state.accountBook.closePeriod;
		let startDate = new Date(
			startPeriod.substring(0, 4) + "-" + startPeriod.substring(4)
		);
		if (this.$store.state.accountBook.closePeriod != null) {
			this.changeStartDate = this.$utils
				.dateAdd(startDate, "month", 1)
				.getTime();
		} else {
			this.changeStartDate = startDate.getTime();
		}
		return {
			disabledDate: (time: any) => {
				return time.getTime() < this.changeStartDate;
			}
		}
	}

	hasForeign: boolean = false;

	// 行数
	rows: any = [];

	// 科目列表
	subjectList: any = [];

	theadName: string = "";
	loanTotal: any = 0;
	creditTotal: any = 0;
	showChineseTotal: boolean = false;
	chineseTotal: string = "";

	writtenPerson: any = this.$store.state.account.name;
	canNotSave: boolean = true;
	canNotSaveAndAdd: boolean = true;
	showSaveAndAdd: boolean = true;
	showAdd: boolean = false;

	hasASave: boolean = false; // 暂存数据,以作比较,

	// 用于获取新增科目时点击所在行
	tmpIndex: any = null;
	tmpId: any = null;

	// 判断是否改变日期并获取最新记字号
	shouldGetInit: boolean = true;

	// 判断是否显示凭证模板的选项框
	showTpOptions: boolean = false;
	showSaveTp: boolean = false; // 是否显示存为模板确认框
	showUseTp: boolean = false; //是否显示使用模板
	isTp: boolean = false;
	tpName: string = "";
	canNotSaveTp: boolean = true;
	tpData: any = {}; // 模板数据
	tpId: any = null;
	tpInit: number = 0;
	// 是否显示辅助核算模态框
	showAddAssist: boolean = false;
	type: any = null;
	newNo: any = null;
	newUnit: null | string = null;
	noBalance: boolean = false;
	shouldBack: boolean = true;
	loading: boolean = false;

	saveBackup() {
		if (this.shouldBack && !this.isDialog) {
			console.log("save backup")
			let v = this.getPackData(true);
			if (v) {
				if (v.voucherRecords.length != 0)
					localStorage.setItem("backupVoucher", JSON.stringify(v));
				else localStorage.removeItem("backupVoucher");
			}
		} else {
			localStorage.removeItem("backupVoucher");
		}
		
	}
	beforeDestroy() {
		this.saveBackup();
		let tip: any = document.querySelector(".staticTip");
		if (tip != null) tip.style.display = "none";
	}

	@Watch("voucherNo")
	voucherNoChange(val: any) {
		if (!this.isTp) (<any>this.$refs).info.noCopy = val;
	}

	@Watch("accessoryNo")
	accessoryNoChange(val: any) {
		(<any>this.$refs).info.accessoryNum = val;
	}

	@Watch("dateTime")
	dateTimeChange(val: any, old: any) {
		if (toString.call(old) === "[object Date]") {
			if (
				val.getMonth() != old.getMonth() ||
				(val.getFullYear() != old.getFullYear() &&
					JSON.stringify(old) != "{}")
			)
				this.changeDate(this.$utils.simpleDateFormat(val, "m", true));
		}
	}

	@Watch("rows", { deep: true })
	rowsChange(val: any, old: any) {
		let has = false;
		for (var i = 0; i < val.length; i++) {
			if (val[i].measuringUnit != null || val[i].currSymbol != null) {
				has = true;
				break;
			} else {
				has = false;
			}
		}
		// 模板状态不显示数量外币
		has && !this.isTp
			? (this.hasForeign = true)
			: (this.hasForeign = false);
		if (this.hasASave) {
			this.canNotSave = false;
			this.canNotSaveAndAdd = false;
			this.hasASave = false;
		}
	}

	@Watch("loanTotal")
	loanTotalChange(val: any) {
		if (val == +this.creditTotal) {
			this.showChineseTotal = true;
			this.chineseTotal = this.dXie(this.loanTotal);
			if (Number(val) == 0) {
				this.chineseTotal = this.dXie(0);
			}
		} else {
			this.showChineseTotal = false;
		}
	}

	@Watch("creditTotal")
	creditTotalChange(val: any) {
		if (val == this.loanTotal) {
			this.showChineseTotal = true;
			this.chineseTotal = this.dXie(this.creditTotal);
			if (Number(val) == 0) {
				this.chineseTotal = this.dXie(0);
			}
		} else {
			this.showChineseTotal = false;
		}
	}

	@Watch("showChineseTotal")
	showChineseTotalChange(val: any) {
		if (!val) {
			this.canNotSave = true;
			this.canNotSaveAndAdd = true;
		} else {
			this.canNotSave = false;
			this.canNotSaveAndAdd = false;
		}
	}

	@Watch("isTp")
	isTpChange(val: any) {
		if (val) {
			this.canNotSaveTp = false;
			this.canNotSave = false;
		}
	}

	@Watch("showAddAssist")
	showAddAssistChange(val: any) {
		if (!val) {
			let assistModalInput: any =
				document.querySelector(".assistModal input");
			assistModalInput.focus();
		}
	}
	newPeriod: any = "";
	mounted() {
		this.newPeriod = this.$route.query.period;
		this.$nextTick(() => {
			this.loading = true;
			let rowSummaryInput: any =
				document.querySelector(".rowSummary textarea");
			if (this.shouldGetInit) {
				this.getInit(true, false, false, (response: any) => {
					if (localStorage.backupVoucher && !this.isCate) {
						let backup = JSON.parse(localStorage.backupVoucher);
						if (
							backup.accountBookId ==
							this.$store.state.accountBook.id
						) {
							if (backup.voucherRecords.length != 0) {
								this.packVoucher(backup);
							}
						}
						this.loading = false;
					} else {
						this.loading = false;
					}
					(<any>document.querySelector(".rowSummary textarea")).focus();
				});
			} else {
				this.loading = false;
			}
		});
	}

	getTpType(cate: any) {
		if (cate === 3) return "日记账";
		else if (cate === 2) return "进项发票";
		else if (cate === 1) return "销项发票";
		else return "其他票据";
	}

	setFind(getSub: any, response: any, then: any) {
		this.voucherNo = response.data.currentNo;
		//根据后台字段判断上一张下一张凭证按钮是否可点
		if (response.data.previous == 0) {
			this.canFindPre = true;
		} else {
			this.canFindPre = false;
		}

		if (response.data.next == 0) {
			this.canFindNext = true;
		} else {
			this.canFindNext = false;
		}
		let voucherEditInput: any = document.querySelector(
			"textarea[name=voucherEdit]"
		);
		voucherEditInput.focus();
		//getSub判断是否需要获取科目列表
		if (getSub) {
			this.getSubjectList(null, then);
		}
	}

	// 初始化,获取记字号
	getInit(getSub: any, curPer?: any, preNo?: any, then?: any) {
		this.resetVoucher();

		this.writtenPerson = this.$store.state.account.name;
		var period = "";
		var year = "";
		var month = "";
		if (!curPer && !preNo) {
			let _this = this;
			Vue.axios
				.post("vouchers/getinit", {
					accountBookId: this.$store.state.accountBook.id,
					period: this.newPeriod,
				})
				.then((response) => {
					_this.dateTime = new Date(response.data.voucherDate);
					_this.setFind(getSub, response, then);
				});
		} else if (!preNo && curPer) {
			let _this = this;
			Vue.axios
				.post("vouchers/getinit", {
					accountBookId: this.$store.state.accountBook.id,
					period: curPer,
				})
				.then((response) => {
					//根据后台字段判断上一张下一张凭证按钮是否可点
					_this.setFind(getSub, response, then);
					//getSub判断是否需要获取科目列表
				});
		} else {
			let _this = this;
			Vue.axios
				.post("vouchers/getinit", {
					accountBookId: this.$store.state.accountBook.id,
					period: curPer,
					preNo: preNo,
				})
				.then((response) => {
					_this.dateTime = new Date(response.data.voucherDate);
					//根据后台字段判断上一张下一张凭证按钮是否可点
					_this.setFind(getSub, response, then);
					_this.isInsert = 1;
					//getSub判断是否需要获取科目列表
				});
		}
	}

	toNextRow(index: any) {
		let rowSummary: any = document.querySelectorAll(".rowSummary");
		if (index != this.rows.length - 1) {
			rowSummary[index + 1].querySelector("textarea").focus();
		} else {
			this.addRow(index, new defaultRecords().one);
			this.$nextTick(() => {
				(<any>document.querySelectorAll(".rowSummary")[index + 1])
					.querySelector("textarea")
					.focus();
			});
		}
	}

	// 产看上下张凭证
	findFn(dir: any) {
		this.shouldGetInit = false;
		let _this = this;
		Vue.axios
			.post("vouchers/findnext", {
				accountBookId: this.$store.state.accountBook.id,
				dir: dir,
				voucherNo: this.voucherNo,
				period: this.$utils.simpleDateFormat(this.dateTime, "m"),
			})
			.then((response) => {
				_this.packVoucher(response.data);
				_this.showSaveAndAdd = false;
				_this.showAdd = true;
				_this.shouldBack = false;
				this.$message.success({ message: "加载成功", duration: 580 });
				// this.noBalance = true;
			});
	}

	findprevious() {
		this.findFn(0);
	}
	findnext() {
		this.findFn(1);
	}

	//重置凭证
	resetVoucher() {
		this.id = null;
		this.accessoryNo = "";
		this.isInsert = 0;
		this.tpName = "";
		this.noBalance = false;
		this.rows = new defaultRecords().rows;
		this.loanTotal = 0;
		this.creditTotal = 0;
		this.category = null;
	}

	// 打包数据到凭证
	packVoucher(voucher: any) {
		let hasF = false;
		this.resetVoucher();

		// this.noBalance = true;
		if (!this.isTp) {
			this.id = voucher.id;
			this.voucherNo = voucher.voucherNo;
			this.accessoryNo =
				voucher.accessoryNo == 0 ? "" : voucher.accessoryNo;
			this.dateTime = new Date(voucher.voucherDate);
			this.writtenPerson =
				voucher.writtenPerson == null
					? this.$store.state.account.name
					: voucher.writtenPerson;
			this.state = voucher.state;
			this.auditPerson = voucher.auditPerson;
			this.auditDate = voucher.auditDate;
			this.category = voucher.category;
		}
		// this.canFindPre = voucher.previous === 1;
		// this.canFindNext = voucher.next === 1;
		for (var i = 0; i < voucher.voucherRecords.length; i++) {
			let vr = voucher.voucherRecords[i];
			if (!this.isTp) {
				let org = 0,
					number = 0;
				if (vr.jfmoney != 0) {
					org = vr.jfmoneyOrg;
					number = vr.jfnumber;
				} else if (vr.dfmoney != 0) {
					org = vr.dfmoneyOrg;
					number = vr.dfnumber;
				}
				if (vr.measuringUnit != null || vr.currSymbol != null) {
					hasF = true;
					if (vr.measuringUnit != null && vr.currSymbol == null) {
						this.theadName = "数量";
					}
					if (vr.measuringUnit == null && vr.currSymbol != null) {
						this.theadName = "外币";
					}
					if (vr.measuringUnit != null && vr.currSymbol != null) {
						this.theadName = "数量/外币";
					}
				}
			}
			let sub: any = {},
				index = i;
			for (var t = 0; t < this.subjectList.length; t++) {
				let v = this.subjectList[t];
				if (v.id == vr.subjectId) {
					sub = Object.assign(v, vr.subject)
					break;
				}
			}
			let relations = vr.relation;
			if (relations != null) {
				vr.assist = {};
				Object.keys(vr.relation).forEach((attr: string) => {
					if (attr.includes("dimProvider")) {
						if (vr.relation[attr] !== null && vr.relation[attr].no) vr.assist["供应商"] = vr.relation[attr];
					}
					if (attr.includes("dimEmployee")) {
						if (vr.relation[attr] !== null && vr.relation[attr].no) vr.assist["员工"] = vr.relation[attr];
					}
					if (attr.includes("dimInventory")) {
						if (vr.relation[attr] !== null && vr.relation[attr].no) vr.assist["存货"] = vr.relation[attr];
					}
					if (attr.includes("dimCustomer")) {
						if (vr.relation[attr] !== null && vr.relation[attr].no) vr.assist["客户"] = vr.relation[attr];
					}
					if (attr.includes("dimDepartment")) {
						if (vr.relation[attr] !== null && vr.relation[attr].no) vr.assist["部门"] = vr.relation[attr];
					}
					if (attr.includes("dimItem")) {
						if (vr.relation[attr] !== null && vr.relation[attr].no) vr.assist["项目"] = vr.relation[attr];
					}
				});
			}
			
			if (vr.measuringUnit !== null) sub.measuringUnit = vr.measuringUnit;
			if (vr.currSymbol !== null) sub.currSymbol = vr.currSymbol;
			if (!vr.assistantAccountId && vr.relation) vr.assistantAccountId = vr.relation.id;
			if (index > 4) {
				let record = {};
				if (!this.isTp) {
					record = {
						summary: vr.summary,
						subject: sub,
						foresubText: vr.foresubText,
						subjectId: vr.subjectId,
						jfmoney: vr.jfmoney == 0 ? "" : vr.jfmoney,
						dfmoney: vr.dfmoney == 0 ? "" : vr.dfmoney,
						measuringUnit: vr.measuringUnit,
						currSymbol: vr.currSymbol,
						jfmoneyOrg: vr.jfmoneyOrg,
						dfmoneyOrg: vr.dfmoneyOrg,
						org: vr.jfmoneyOrg == 0 ? vr.dfmoneyOrg : vr.jfmoneyOrg,
						jfnumber: vr.jfnumber,
						dfnumber: vr.dfnumber,
						number: vr.jfnumber == 0 ? vr.dfnumber : vr.jfnumber,
						exchangeRate: vr.exchangeRate,
						unitPrice: vr.unitPrice,
						dimAccountType: vr.dimAccountType,
						assistantAccountId: vr.assistantAccountId,
						relation: vr.relation,
						assist: vr.assist,
						assistList: vr.assistList,
						endnumber : vr.balance ? vr.balance.endnumber : 0,
						endbalance : vr.balance ? vr.balance.endbalance : 0,
						endbalanceOrg : vr.balance ? vr.balance.endbalanceOrg : 0,
					};
				} else {
					record = {
						summary: vr.summary,
						subject: sub,
						foresubText: vr.foresubText,
						subjectId: vr.subjectId,
						jfmoney: vr.jfmoney == 0 ? "" : vr.jfmoney,
						dfmoney: vr.dfmoney == 0 ? "" : vr.dfmoney,
						dir: vr.dir,
						measuringUnit: null,
						currSymbol: null,
						jfmoneyOrg: null,
						dfmoneyOrg: null,
						org: 0,
						jfnumber: 0,
						dfnumber: 0,
						number: 0,
						exchangeRate: 0,
						unitPrice: 0,
						dimAccountType: vr.dimAccountType,
						assistantAccountId: vr.assistantAccountId,
						relation: vr.relation,
						assist: vr.assist,
						assistList: vr.assistList,
						endnumber : vr.balance ? vr.balance.endnumber : 0,
						endbalance : vr.balance ? vr.balance.endbalance : 0,
						endbalanceOrg : vr.balance ? vr.balance.endbalanceOrg : 0,
					};
				}
				this.rows.push(record);
			} else {
				if (!this.isTp) {
					this.rows[index].summary = vr.summary;
					this.rows[index].foresubText = vr.foresubText;
					this.rows[index].subjectId = vr.subjectId;
					this.rows[index].subject = sub;
					this.rows[index].jfmoney =
						vr.jfmoney == 0 ? "" : vr.jfmoney;
					this.rows[index].dfmoney =
						vr.dfmoney == 0 ? "" : vr.dfmoney;
					this.rows[index].measuringUnit = vr.measuringUnit;
					this.rows[index].currSymbol = vr.currSymbol;
					this.rows[index].org =
						vr.jfmoneyOrg == 0 ? vr.dfmoneyOrg : vr.jfmoneyOrg;
					this.rows[index].number =
						vr.jfnumber == 0 ? vr.dfnumber : vr.jfnumber;
					this.rows[index].exchangeRate = vr.exchangeRate;
					this.rows[index].unitPrice = vr.unitPrice;
					this.rows[index].dimAccountType = vr.dimAccountType;
					this.rows[index].assistantAccountId = vr.assistantAccountId;
					this.rows[index].relation = vr.relation;
					this.rows[index].assist = vr.assist;
					this.rows[index].assistList = vr.assistList;
					if (vr.balance) {
						this.rows[index].endnumber = vr.balance.endnumber;
						this.rows[index].endbalance = vr.balance.endbalance;
						this.rows[index].endbalanceOrg = vr.balance.endbalanceOrg;
					}

				} else {
					this.rows[index].summary = vr.summary;
					this.rows[index].foresubText = vr.foresubText;
					this.rows[index].subjectId = vr.subjectId;
					this.rows[index].subject = sub;
					this.rows[index].dir = vr.dir;
					this.rows[index].jfmoney =
						vr.jfmoney == 0 ? "" : vr.jfmoney;
					this.rows[index].dfmoney =
						vr.dfmoney == 0 ? "" : vr.dfmoney;
					this.rows[index].measuringUnit = null;
					this.rows[index].currSymbol = null;
					this.rows[index].org = 0;
					this.rows[index].number = 0;
					this.rows[index].exchangeRate = 0;
					this.rows[index].unitPrice = 0;
					this.rows[index].dimAccountType = vr.dimAccountType;
					this.rows[index].assistantAccountId = vr.assistantAccountId;
					this.rows[index].relation = vr.relation;
					this.rows[index].assist = vr.assist;
					this.rows[index].assistList = vr.assistList;
					if (vr.balance) {
						this.rows[index].endnumber = vr.balance.endnumber;
						this.rows[index].endbalance = vr.balance.endbalance;
						this.rows[index].endbalanceOrg = vr.balance.endbalanceOrg;
					}

				}
			}
		}

		this.canFindPre = voucher.previous === 0;
		this.canFindNext = voucher.next === 0;

		if (hasF && !this.isTp) {
			this.hasForeign = true;
		}

		this.$nextTick(() => {
			this.loanTotal = Number(voucher.jftotal).toFixed(2);
			this.creditTotal = Number(voucher.dftotal).toFixed(2);
			this.fitMoney();
		});
	}

	// 获取records的assit对象属性值和顺序
	transRelation(val: string) {
		switch (val) {
			case "dimItemId":
				return 5;
			case "dimCustomerId":
				return 3;
			case "dimDepartmentId":
				return 4;
			case "dimEmployeeId":
				return 1;
			case "dimInventoryId":
				return 2;
			case "dimProviderId":
				return 0;
			default:
				return null;
		}
	}

	// 修改No
	changeNo(val: any) {
		this.voucherNo = val;
	}

	//修改日期
	changeDate(val: any, date?: any) {
		if (this.shouldGetInit) {
			let period = val.split("-")[0] + val.split("-")[1];
			this.getSubjectList(null, this.getInit(false, period));
		}
	}

	changeAcc(val: any) {
		this.accessoryNo = val;
	}

	/*
		凭证分录内所需的方法
	*/
	//获取科目列表
	getSubjectList(period: any, then: any) {
		let that = this;

		if (this.isTp) {
			Vue.axios
				.post("subjects/findall", {
					accountBookId: this.$store.state.accountBook.id,
				})
				.then((response) => {
					response.data.subjects.forEach((v: any) => {
						v.balance.assist = {};
					});
					that.subjectList = response.data.subjects;
					// 获取科目后再执行函数
					if (then) then();
				});
		} else {
			Vue.axios
				.post("subjects/findleaf", {
					accountBookId: this.$store.state.accountBook.id,
				})
				.then((response) => {
					response.data.forEach((v: any) => {
						v.balance.assist = {};
					});

					that.subjectList = response.data;

					// 获取科目后再执行函数
					if (then) then();
				});
		}
	}

	// 隐藏增删图标
	hideAllBtn() {
		let allBtn: any = document.querySelectorAll(".rowBtn");
		allBtn.forEach((v: any, i: any, a: any) => {
			v.style.display = "none";
		});
	}

	addRow(index: any, row: any) {
		this.rows.splice(index + 1, 0, row);
	}

	deleteRow(i: any) {
		// (<any>this.$refs).records[i].
		Vue.delete(this.rows, i);
		this.$nextTick(() => {
			(<any>this.$refs).records[this.rows.length - 1].jfBlur(0, true);
			(<any>this.$refs).records[this.rows.length - 1].dfBlur(0, true);
		});
	}

	async fitMoney() {
		let records = (<any>this.$refs).records;
		for (let i = 0; i < records.length; i++) {
			const v = records[i];
			// if (this.rows[i].assistantAccountId) await v.confirmAssist(true, true);
			
			v.jfTemp = +this.rows[i].jfmoney;
			v.dfTemp = +this.rows[i].dfmoney;

			v.fitMoney("jfmoney");
			v.fitMoney("dfmoney");

			v.jfTempChange(0, +this.rows[i].jfmoney, +this.rows[i].jfmoney);
			v.dfTempChange(0, +this.rows[i].dfmoney, +this.rows[i].dfmoney);
		}
			
	}

	// 更新借贷总金额
	addJf(val: any) {
		this.loanTotal = 0;
		for (var i = 0; i < this.rows.length; i++) {
			if (this.rows[i].jfmoney != "" && this.rows[i].jfmoney != 0) {
				this.loanTotal = +this.rows[i].jfmoney + +this.loanTotal;
				this.loanTotal = (+this.loanTotal).toFixed(2);
			}
		}
	}
	addDf(val: any) {
		// this.creditTotal += +val
		this.creditTotal = 0;
		for (var i = 0; i < this.rows.length; i++) {
			if (this.rows[i].dfmoney != "" && this.rows[i].dfmoney != 0) {
				this.creditTotal = +this.rows[i].dfmoney + +this.creditTotal;
				this.creditTotal = (+this.creditTotal).toFixed(2);
			}
		}
	}

	// 中文大写
	dXie(n: any) {
		var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
			str = "";
		n += "00";
		var p = n.indexOf(".");
		if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
		unit = unit.substr(unit.length - n.length);
		for (var i = 0; i < n.length; i++)
			str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
		if (String(n).indexOf("-") == -1) {
			if (/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
				return str
					.replace(/零(仟|佰|拾|角)/g, "零")
					.replace(/(零)+/g, "零")
					.replace(/零(万|亿|元)/g, "$1")
					// .replace(/(亿)万|壹(拾)/g, "$1$2")
					.replace(/^元零?|零分/g, "")
					.replace(/元$/g, "元整");
			} else {
				if (n == "000") return "零元整";
				else {
					return str
						.replace(/零(仟|佰|拾|角)/g, "零")
						.replace(/(零)+/g, "零")
						.replace(/零(万|亿|元)/g, "$1")
						// .replace(/(亿)万|壹(拾)/g, "$1$2")
						.replace(/^元零?|零分/g, "")
						.replace(/元$/g, "元整");
				}
			}
		} else {
			let newStr = str
				.replace(/零(仟|佰|拾|角)/g, "零")
				.replace(/(零)+/g, "零")
				.replace(/零(万|亿|元)/g, "$1")
				// .replace(/(亿)万|壹(拾)/g, "$1$2")
				.replace(/^元零?|零分/g, "")
				.replace(/元$/g, "元整"),
				need = newStr.slice(1),
				show = "负".concat(need);
			return show;
		}
	}

	// 打包凭证数据
	getPackData(noNotice?: any) {
		if (this.loanTotal != this.creditTotal && !noNotice) {
			this.$message.error("借贷不平衡！");
			return false;
		}
		if (this.dateTime.getFullYear) {
			let rows = this.rows;
			let voucher: any = {
				accessoryNo: this.accessoryNo,
				accountBookId: this.$store.state.accountBook.id,
				dftotal: +this.creditTotal,
				jftotal: +this.loanTotal,
				id: this.id,
				period: this.$utils.simpleDateFormat(this.dateTime, "m"),
				voucherDate: this.$utils.simpleDateFormat(
					this.dateTime,
					"d",
					true
				),
				voucherNo: this.voucherNo,
				writtenPerson: this.writtenPerson,
				voucherRecords: [],
				category: this.category,
			};

			for (var i = 0; i < rows.length; i++) {
				if (
					rows[i].jfmoney != "" ||
					rows[i].dfmoney != "" ||
					rows[i].foresubText.indexOf("本年利润") != -1
				) {
					if (rows[i].summary == "" && !noNotice) {
						this.$message.error("摘要不能为空！");
						throw "wrong";
					}
					if (rows[i].foresubText == "" && !noNotice) {
						this.$message.error("科目不能为空！");
						throw "wrong";
					}
					let newVr: any = {
						assistantAccountId: null,
						dfmoney: 0,
						dfmoneyOrg: 0,
						dfnumber: 0,
						exchangeRate: 0,
						foresubText: "",
						jfmoney: 0,
						jfmoneyOrg: 0,
						jfnumber: 0,
						subject: {},
						subjectId: null,
						summary: "",
						unitPrice: 0,
						relation: null,
						assist: null,
						measuringUnit: null,
						currSymbol: null,
					};
					if (rows[i].jfmoney != "" && rows[i].dfmoney == "") {
						rows[i].jfmoney = +rows[i].jfmoney;
						rows[i].dfmoney = +rows[i].dfmoney;
						rows[i].jfmoneyOrg = +rows[i].org;
						rows[i].jfnumber = +rows[i].number;

						rows[i].dfnumber = 0;
					} else {
						rows[i].jfmoney = +rows[i].jfmoney;
						rows[i].dfmoney = +rows[i].dfmoney;
						rows[i].dfmoneyOrg = +rows[i].org;
						rows[i].dfnumber = +rows[i].number;

						rows[i].jfnumber = 0;
					}
					Object.keys(newVr).forEach((attr: string) => {
						newVr[attr] = rows[i][attr];
					});
					console.log(newVr.assist)
					voucher.voucherRecords.push(newVr);
				}
			}
			return voucher;
		}
	}

	/*
		1.保存凭证
		2.保存并新增
		3.新增凭证
	*/
	saveFn(type: any, cb: any) {
		let mes: any = "",
			data: any = this.getPackData(),
			_this = this;
		if (data && data.voucherRecords.length > 1) {
			if (type == "update") mes = "修改";
			else if (type == "insert") mes = "插入";
			else mes = "保存";
			Vue.axios.post("vouchers/" + type, data).then((response) => {
				this.$message.success({
					message: mes + "成功",
					duration: 1000,
				});
				if (cb) cb(response);
			});
			// this.newPeriod = "";
		} else if (data.voucherRecords.length <= 1) {
			this.$message.error("亲，请至少录入两条分录！");
		}
	}
	clickSaveTp() {
		if (this.tpName != "") {
			if (this.saveTp() != "wrong") {
				this.createTemplate(
					this.tpName,
					true,
					this.tpId,
					this.tpInit,
					() => {
						this.$emit("save");
					}
				);
			}
		} else {
			this.$alert("亲，模板名称不能为空！", "温馨提示");
		}
	}
	saveVoucher(then: any) {
		if (!this.notEdit) {
			if (!this.isTp) {
				if (!this.canNotSave && this.$utils.canControl()) {
					if (this.id != null && this.isInsert == 0) {
						this.saveFn("update", (response: any) => {
							this.hasASave = true;
							this.shouldBack = false;
							this.id = response.data.id;
							this.canNotSave = true;
							this.canNotSaveAndAdd = true;
							if (then) this.addVoucher();
						});
					} else if (this.isInsert == 1) {
						this.saveFn("insert", (response: any) => {
							this.isInsert = 0;
							this.hasASave = true;
							this.shouldBack = false;
							this.id = response.data.id;
							if (then) this.addVoucher();
						});
					} else if (this.id == null) {
						this.saveFn("create", (response: any) => {
							this.id = response.data.id;
							this.hasASave = true;
							this.shouldBack = false;
							this.canNotSave = true;
							this.canNotSaveAndAdd = true;
							this.showSaveAndAdd = false;
							if (!this.isDialog) this.showAdd = true;
							if (then) this.addVoucher();
						});
					}
				}
			} else {
				this.clickSaveTp();
			}
		}
	}
	saveAndAdd() {
		if (!this.canNotSaveAndAdd) {
			this.saveVoucher(true);
			this.shouldGetInit = true;
		}
	}
	addVoucher() {
		this.resetVoucher();
		this.getInit(true);
		this.showSaveAndAdd = true;
		this.showAdd = false;
		this.shouldGetInit = true;
		this.canNotSave = true;
		this.canNotSaveAndAdd = true;
	}

	// 新增科目
	addSub(i: any) {
		this.tmpIndex = i;
		this.addDialog = true;
		this.$nextTick(() => {
			let addSubInput: any = document.querySelector(".addSub input");
			addSubInput.focus();
		});
	}

	confirmAddSub(val: any) {
		this.getSubjectList(null, () => {
			let sub: any = {};
			this.subjectList.forEach((v: any, i: any, a: any) => {
				if (v.id == val.id) sub = v;
			});
			this.rows[this.tmpIndex].subject = sub;
			this.getCurRow().then((current: any) => {
				current.changeSubject(sub);
				current.showSubjectText = true;
				this.addDialog = false;
			});
		});
	}

	/*
		凭证模板
	*/
	// 获取模板格式数据
	getTpData(data: any) {
		let upload: any = [];
		data.forEach((v: any, i: any, a: any) => {
			if (v.jfmoney == "") v.jfmoney = 0;
			if (v.dfmoney == "") v.dfmoney = 0;
			let record = {
				dfmoney: v.dfmoney,
				jfmoney: v.jfmoney,
				dir: +v.subject.direction === 1 ? 1 : -1,
				summary: v.summary,
				relation: v.relation,
				subjectNo: v.subject.no,
			};
			upload.push(record);
		});
		return upload;
	}
	// 存为模板
	saveTp() {
		let data = [];
		for (var i = 0; i < this.rows.length; i++) {
			let v = this.rows[i],
				d = {};
			if (v.summary != "") {
				if (JSON.stringify(v.subject) != "{}") {
					data.push(v);
				} else {
					this.$alert("亲，科目不能为空！", "温馨提示");
					throw "wrong";
				}
			} else if (JSON.stringify(v.subject) != "{}") {
				this.$alert("亲，摘要不能为空！", "温馨提示");
				throw "wrong";
			}
		}
		if (data.length < 2) {
			this.$alert("亲，请录入至少2行分录！", "温馨提示");
			return "wrong";
		} else {
			let needData = this.getTpData(data);
			if (!this.isTp) {
				this.showSaveTp = true;
			}
			this.tpData = needData;
			return needData;
		}
	}

	// 显示使用模板模态框
	useTp() {
		if (this.isDialog) {
			if (this.id == null) this.showUseTp = true;
		} else {
			this.showUseTp = true;
		}
	}

	// 保存模板
	createTemplate(
		tpName: any,
		saveNumber: any,
		id: any,
		isInit: any,
		fn: any
	) {
		let sId = id ? id : null;
		if (!saveNumber) {
			this.tpData.forEach((v: any, i: any, a: any) => {
				v.jfmoney = 0;
				v.dfmoney = 0;
				v.dir = 1;
			});
		}
		if (!this.isCate) {
			Vue.axios
				.post("vouchertemplate/save", {
					accountBookId: this.$store.state.accountBook.id,
					id: sId,
					isInit: isInit,
					showName: tpName,
					records: this.tpData,
				})
				.then((response: any) => {
					if (fn) fn();
				});
		} else {
			Vue.axios
				.post("vouchertemplate/save", {
					accountBookId: this.$store.state.accountBook.id,
					id: sId,
					isInit: isInit,
					showName: tpName,
					records: this.tpData,
					cate: this.cate,
				})
				.then((response: any) => {
					if (fn) fn();
				});
		}
		this.showSaveTp = false;
	}

	packTp(records: any) {
		this.rows = new defaultRecords().rows;
		this.theadName = "";
		for (var i = 0; i < records.length; i++) {
			let vr: any = records[i],
				sub: any = {};
			for (let z = 0; z < this.subjectList.length; z++) {
				if (+this.subjectList[z].id === +vr.subjectId) {
					sub = this.subjectList[z];
					sub.balance.assist =
						vr.subject != undefined
							? vr.subject.balance.assist
							: {};
					break;
				}
			}
			if (!vr.assist) {
				vr.assist = {};
				if (sub.dimAccountTypes) {
					sub.dimAccountTypes.forEach((v: any) => {
						vr.assist[v] = "";
					});
				}
			}

			if (i > 4) {
				let record: any = {
					summary: vr.summary,
					subject: sub,
					foresubText: vr.foresubText,
					subjectId: vr.subjectId,
					jfmoney: vr.jfmoney == 0 ? "" : vr.jfmoney,
					dfmoney: vr.dfmoney == 0 ? "" : vr.dfmoney,
					measuringUnit: vr.measuringUnit,
					currSymbol: vr.currSymbol,
					jfmoneyOrg: 0,
					dfmoneyOrg: 0,
					org: 0,
					jfnumber: 0,
					dfnumber: 0,
					number: 0,
					exchangeRate: 0,
					unitPrice: 0,
					dimAccountType: vr.dimAccountType || sub.dimAccountType,
					assistantAccountId: vr.assistantAccountId,
					assist: vr.assist,
					assistList: vr.assistList,
					relation: vr.relation,
				};
				this.rows.push(record);
			} else {
				this.rows[i].summary = vr.summary;
				this.rows[i].foresubText = vr.foresubText;
				this.rows[i].subjectId = vr.subjectId;
				this.rows[i].subject = sub;
				this.rows[i].jfmoney = vr.jfmoney;
				this.rows[i].dfmoney = vr.dfmoney;
				this.rows[i].measuringUnit = vr.measuringUnit;
				this.rows[i].currSymbol = vr.currSymbol;
				this.rows[i].org = 0;
				this.rows[i].number = 0;
				this.rows[i].exchangeRate = 0;
				this.rows[i].unitPrice = 0;
				this.rows[i].dimAccountType =
					vr.dimAccountType || sub.dimAccountType;
				this.rows[i].assistantAccountId = vr.assistantAccountId;
				this.rows[i].relation = vr.relation;
				this.rows[i].assist = vr.assist;
			}

			if (sub.measuringUnit != null || sub.currSymbol != null) {
				if (sub.measuringUnit != null && sub.currSymbol == null) {
					if (this.theadName == "") this.theadName = "数量";
					else this.theadName = "数量/外币";
				}
				if (sub.measuringUnit == null && sub.currSymbol != null) {
					if (this.theadName == "") this.theadName = "外币";
					else this.theadName = "数量/外币";
				}
				if (sub.measuringUnit != null && sub.currSymbol != null) {
					this.theadName = "数量/外币";
				}
			}
		}
		this.$nextTick(() => {
			this.fitMoney();
			(<any>this.$refs).records.forEach((v: any, i: any, a: any) => {
				v.tempSubject = {};
				v.noChange = true;
				v.jfTemp = +this.rows[i].jfmoney;
				v.dfTemp = +this.rows[i].dfmoney;
				v.tempSubject = this.rows[i].subject;
				// this.rows[i].subject = v.tempSubject
				if (
					this.rows[i].assist != null &&
					JSON.stringify(this.rows[i].assist) != "{}" &&
					this.rows[i].assist.length > 0
				) {
					// v.assist = { id: this.rows[i].assistantAccountId };
					v.confirmAssist(true);
				}

				this.$nextTick(() => {
					v.noChange = false;
				});
				this.loanTotal += +this.rows[i].jfmoney;
				this.creditTotal += +this.rows[i].dfmoney;
			});
			this.hasASave = true;
		});
	}

	// 使用这张模板
	rightTheTp(tp: any) {
		this.showUseTp = false;
		let id = this.id,
			isInsert = this.isInsert;
		this.resetVoucher();
		this.id = id;
		this.isInsert = isInsert;
		this.getSubjectList(true, () => {
			this.packTp(tp.voucherRecords);
		});
	}

	// 显示新增辅助核算模态框
	assistSelIndex: number = 0;
	assistSelName: string = "";
	addAssist(name: any, no: any, index: any, aIndex: number) {
		this.showAddAssist = true;
		this.assistSelIndex = aIndex;
		this.assistSelName = name;
		this.type = name;
		this.newNo = no;
		this.tmpIndex = index;
		this.$nextTick(() => {
			(<any>this.$refs).addAssist.initData();
			let addAssitInput: any =
				document.querySelectorAll(".addAssist input")[1];
			addAssitInput.focus();
		});
	}

	confirmAddAssist(response: any) {
		this.getCurRow().then((current: any) => {
			this.showAddAssist = false;
			current.getAssistList(this.assistSelName, () => {
				if (this.rows[this.tmpIndex].assist === null)
					this.rows[this.tmpIndex].assist = {};
				this.rows[this.tmpIndex].assist[this.assistSelName] = {
					no: response.data.no,
					name: response.data.name,
					id: response.data.id,
				};
				current.$refs["dimistSelect-" + this.assistSelIndex][0].blur();
				current.changeAssist(
					response.data,
					this.rows[this.tmpIndex].subject.dimAccountTypes.length -
					1 ===
					this.assistSelIndex,
					this.assistSelIndex
				);
			});
			this.showAddAssist = false;
		});
	}

	//获取当前行的id
	getCurRow() {
		return new Promise((resolve, reject) => {
			let arr = [];
			let backVal;
			for (var i = 0; i < (<any>this.$refs).records.length; i++) {
				if ((<any>this.$refs).records[i]._uid === this.tmpId) {
					arr.push(i);
					backVal = (<any>this.$refs).records[i];
					break;
				}
			}
			if (arr.length <= 0) reject("wrong");
			resolve(backVal);
		});
	}

	// 审核凭证相关
	notEdit: boolean = false;
	state: number = 0;
	auditPerson: string = "";
	auditDate: string = "";

	category = null;

	async delVoucher() {
		if (this.$utils.canControl()) {
			const action = await this.$confirm("此操作将永久删除该凭证, 是否继续?", "温馨提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			});
			if (action === "confirm") {
				await Vue.axios.post(`vouchers/delete`, this.getPackData());
				this.addVoucher();
			}
		}
	}

	// 凭证内红冲凭证
	showCopy = false;
	redRush() {
		this.showCopy = true;
	}
	afterReset() {
		this.showCopy = false;
	}

}
